import React from 'react';
import {useSelector} from "react-redux";
import Crew from "./crew";
import Profile from "./agent";

const Index = () => {
  const user = useSelector((state) => state.user.user)

  return (
    <>
      {
        (user?.role_key === "crew" ||  !user?.role_key )   ?
          <Crew/>
          :
          <Profile/>
      }

    </>
  );
};

export default Index;
